import type { CmsSlide, CmsSlidesResponse } from '@/api/types';
import type { ExternalImgPath } from '@/shared/ui';

export const CMS_SLIDES_ENDPOINT = '/cms/slides.json';
const CMS_BASE_URL = import.meta.env.VITE_API_FRONT_APP_URL || '';

export const getCmsSlides = async (): Promise<CmsSlidesResponse | null> => {
  try {
    const response = await fetch(`${CMS_BASE_URL}${CMS_SLIDES_ENDPOINT}`);
    if (!response.ok || response.status === 204) return null;
    const json = (await response.json()) as unknown;
    return normalizeCmsSlidesResponse(json);
  } catch {
    return null;
  }
};

const normalizeCmsSlidesResponse = (payload: unknown): CmsSlidesResponse | null => {
  const slides = Array.isArray(payload)
    ? payload
    : payload && typeof payload === 'object' && Array.isArray((payload as CmsSlidesResponse).data)
      ? (payload as CmsSlidesResponse).data
      : null;

  if (!slides) return null;

  return {
    data: slides.map((slide: CmsSlide) => {
      return {
        ...slide,
        img: {
          desktop: `${CMS_BASE_URL}${slide.img.desktop}` as ExternalImgPath,
          mobile: `${CMS_BASE_URL}${slide.img.mobile}` as ExternalImgPath,
        },
      };
    }),
  };
};
